module.exports = __webpack_public_path__ + "static/media/Ground-Back.ab2de7ab.webp";